import { MicrosoftAuth } from '../../../services/auth/microsoft/microsoft'
import { SlackAuth } from '../../../services/auth/slack/slack'
import { GoogleAuth } from '../../../services/auth/google/google'

export const msAuth = new MicrosoftAuth(process.env.REACT_APP_MICROSOFT_CLIENT_ID as string)
export const slackAuth = new SlackAuth(process.env.REACT_APP_SLACK_CLIENT_ID)
export const googleAuth = new GoogleAuth(process.env.REACT_APP_GOOGLE_CLIENT_ID)
